import React, { useEffect, useState } from "react";
import './style.scss';
import OutlinedButton from "../button/button";
import TextInput from "../textInput";
import TextInputDropdown from "../TextInputDropdown/TextInputDropdown";
import ProfessionalCard from "../ProfessionalCard/ProfessionalCard";
import { MenuItem } from "@mui/material";
import FilterDropdown from "../FilterDropDown/FilterDropDown";
const AddData = ({ InputType, MenuItems, getData, closeComponent, SelectedBrief, id, additionalData, style }) => {
    const [SelectedCategory, setSelectedCategory] = useState([...new Set(SelectedBrief.serviceCategory ?? [])]);
    const [SelectedSkills, setSelectedSkills] = useState([...new Set(SelectedBrief.skillsOfProfessional ?? [])]);
    const [SelectedPro, setSelectedPro] = useState([]);
    const [IsProSelected, setIsProSelected] = useState(false);
    const [Brief, setBrief] = useState({ ...SelectedBrief });
    const [Link, setLink] = useState('');
    const [CurrentValue, setCurrentValue] = useState('');
    const [ShortListCpy, setShortListCpy] = useState([]);
    const [Dates, setDates] = useState({
        start: new Date(),
        end: ''
    });

    useEffect(() => {
        if (id === 'addDeliverable') {
            if (Array.isArray(Brief.projectPlan)) {
                const firstItem = Brief.projectPlan[0];
                if (typeof firstItem === 'object' && Array.isArray(firstItem.deliverables)) {

                    Brief.projectPlan[0].deliverables.push({
                        nameOfItem: additionalData,
                        disStartDate: '',
                        disEndDate: '',
                        reverts: 0,
                        duration: 0
                    });
                    Brief.projectPlan[0].deliverables = [...new Set(Brief.projectPlan[0].deliverables)]
                }
            }
            getData(Brief);
            closeComponent();
            return
        };

        let pros = [...new Set(SelectedBrief.shortlist ?? [])];
        pros = pros.map(item => `${item.professional.firstName} ${item.professional.lastName}`);
        if (Array.isArray(additionalData)) {
            additionalData = additionalData.sort((a, b) => {
                if (a.fullName !== null && a.fullName !== undefined && a.firstName && b.firstName) {
                    return a.firstName.localeCompare(b.firstName);
                }
                return 0; // Default return value if conditions are not met
            })
        };
        setSelectedPro(pros);
        setSelectedCategory([...new Set(SelectedBrief.serviceCategory ?? [])]);
    }, [SelectedBrief, additionalData]);

    //#region helper functions
    const formatDate = (dateString) => {
        if (!dateString) return 'YYYY/MM/DD';

        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return new Date().toISOString().split('T')[0];

            return date.toISOString().split('T')[0];
        } catch (error) {
            console.error('Date formatting error:', error);
            return new Date().toISOString().split('T')[0];
        }
    };
    const calculateDurationInDays = (startDate, endDate) => {
        if (!startDate || !endDate) return 0;
        const start = new Date(startDate);
        const end = new Date(endDate);
        return Math.ceil(Math.abs(end - start) / (1000 * 60 * 60 * 24)) || 0;
    };
    function filterSelected(selected, e) {
        if (!selected.includes(e.target.value)) {
            selected.push(e.target.value);
        } else {
            selected = selected.filter(item => item !== e.target.value);
        };
        selected = [...new Set(selected)];

        return selected
    };
    //#endregion

    //#region functions
    function getServCategory(e) {
        let selected = [...SelectedCategory];
        let brief = { ...Brief };

        selected = filterSelected(selected, e);
        brief.serviceCategory = selected;
        brief.typeOfProfessional = selected;

        setCurrentValue(e.target.value);
        setSelectedCategory(selected);
        setBrief(brief);
    };
    function getLink(e) {
        let link = Link;
        link = e.target.value;
        setLink(link);
    };
    function getSkills(e) {
        let selected = [...SelectedSkills];
        let brief = { ...Brief };

        selected = filterSelected(selected, e);
        brief.skillsOfProfessional = selected;

        setCurrentValue(e.target.value);
        setSelectedSkills(selected);
        setBrief(brief);
    };
    function getPros(id) {
        let value = additionalData.find(item => item._id === id);

        handleProfessionalSelection(value);
        setIsProSelected(true);
        setCurrentValue(value);
    };
    const handleProfessionalSelection = (value) => {
        let selected = [...SelectedPro];
        let brief = { ...Brief };
        let shortlisted = [...Brief.shortlist];
        if (typeof value === 'object' && value !== null && value !== undefined) {
            const fullName = `${value.firstName} ${value.lastName}`;

            // Check if professional is already in shortlist
            const isProfessionalInList = brief.shortlist.some(
                item => item.professional._id === value._id
            );
            if (!isProfessionalInList) {
                // Add new professional
                // brief.shortlist.push({ professional: value, status: 'PENDING' });
                shortlisted.push({ professional: value, status: 'PENDING' });
                selected.push(fullName);
            };
        };

        // Ensure arrays are unique
        shortlisted = [...new Set(shortlisted)];
        selected = [...new Set(selected)];

        setShortListCpy(shortlisted);
        setSelectedPro(selected);
        // setBrief(brief);
    };
    function getDates(e) {
        const currId = e.target.id;
        let dates = { ...Dates };
        if (currId === 'start') {
            dates.start = formatDate(e.target.value);
        } else {
            dates.end = formatDate(e.target.value);
        };
        setDates(dates);
    };
    function handleSave() {
        let brief = { ...Brief };
        if (id === 'link') {
            if (Object.keys(brief).includes('projectLinks')) {
                brief.projectLinks.push({ description: '', url: Link });
            } else {
                brief.project.projectLinks.push({ description: '', url: Link });
            };
        };
        if (id === 'proskill') {
            brief.skillsOfProfessional = SelectedSkills;
        };
        if (id === 'addPro') {
            brief.shortlist = ShortListCpy;
        };
        getData(brief);
        closeComponent();
    };
    function handleclose() {
        closeComponent();
    };
    //    #endregion
    if (id !== 'addDeliverable') {
        return (
            <div id='addData_main' className="add-data-container" style={style}>
                <div className="add-data-header">
                    <p style={{ fontWeight: '600' }}>{InputType === 'link' ? `Paste Link below:` : id === 'addPro' ? 'Select Professionals' : id === 'proskill' ? 'Select Professional Skills' : id === 'catservice' ? 'Select Services' : ''}</p>
                </div>
                <div className="content">
                    {InputType === 'link' ? <TextInput type='text' style={{ width: '100%' }} onChange={getLink} placeholder='Paste link here!' /> : ''}
                    {InputType === 'menudropdown' ?
                        id === 'proskill' ?
                            <TextInputDropdown onChange={getSkills} style={{ width: '100%', marginTop: '0.6px' }} placeholder='' label='' multiple={true} value={CurrentValue}>
                                {[...new Set(MenuItems)].map((item, index) => {
                                    const isSelected = SelectedSkills.includes(item);
                                    return (
                                        <MenuItem key={index}
                                            style={{ background: isSelected ? '#6D4194' : '', color: isSelected ? '#fff' : '', width: '96%', alignSelf: 'center', margin: '2px 2%', borderRadius: '8px' }}
                                            value={item} selected={isSelected}
                                        >
                                            {item}
                                        </MenuItem>
                                    );
                                })}
                            </TextInputDropdown>
                            : id === 'catservice' ?
                                <TextInputDropdown onChange={getServCategory} style={{ width: '100%', marginTop: '0.6px' }} placeholder='' label='' multiple={true} value={CurrentValue}>
                                    {[...new Set(MenuItems)].map((item, index) => {
                                        const isSelected = SelectedCategory.includes(item);
                                        return (
                                            <MenuItem key={index}
                                                style={{ background: isSelected ? '#6D4194' : '', color: isSelected ? '#fff' : '', width: '96%', alignSelf: 'center', margin: '2px 2%', borderRadius: '8px' }}
                                                value={item} selected={isSelected}
                                            >
                                                {item}
                                            </MenuItem>
                                        );
                                    })}
                                </TextInputDropdown>
                                : id === 'addPro' ?
                                    <FilterDropdown isSearching={(e) => { if (e) { setIsProSelected(false) } }} ProSelected={getPros} data={[...new Set(additionalData.filter(item => item.firstName).map((item) => `${item.firstName} ${item.lastName} ,${item._id}`))]} />
                                    : null
                        : null
                    }

                    {InputType === 'date' ?
                        <div className="date-container">
                            <TextInput style={{ width: '45%' }} placeholder='Start Date' label='Start Date' type='date' id='start' onChange={getDates} value={formatDate(new Date(Dates.start))} ></TextInput>
                            <TextInput style={{ width: '45%' }} placeholder='End Date' label='End Date' type='date' id='end' onChange={getDates} value={formatDate(new Date(Dates.end))} ></TextInput>
                        </div> :
                        null
                    }

                    <div className="buttons">
                        <OutlinedButton onClick={handleclose}>Cancel</OutlinedButton>
                        {id === 'addPro' && IsProSelected ? <OutlinedButton onClick={handleSave}>Save</OutlinedButton> : null}
                        {id !== 'addPro' && <OutlinedButton onClick={handleSave}>Save</OutlinedButton>}
                    </div>

                    {IsProSelected && Object.keys(CurrentValue).length > 0 ?
                        <div style={{ height: '63dvh', width: '400px', position: 'absolute', left: '100%', top: '-3rem', padding: '2%', display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
                            <ProfessionalCard style={{ backgroundColor: '#F5F6FA', boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', width: '98%', height: '96%' }} id={'addpro'} item={additionalData.find(item => item._id === CurrentValue._id)} handleViewUser={() => { }} />
                        </div>
                        : null
                    }
                </div>
            </div>
        );
    };
};
export default AddData;